// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2VHi7","header":"PatientQuestionnaire_header__HWDAD","info":"PatientQuestionnaire_info__Jl2RI"};